import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { SharedModule } from '../../shared/shared.module'
import { customOpenCreditClaimAttachmentsLayoutConfig } from './credit-claim-attachments-modal/credit-claim-attachments-modal-layout.config'
import { CreditClaimsDetailsModule } from './credit-claims-details/credit-claims-details.module'
import { CreditClaimsHistoryModule } from './credit-claims-history/credit-claims-history.module'
import { NewcreditClaimsWithOrderModule } from './newcredit-claims-with-order/newcredit-claims-with-order.module'
import { NewcreditClaimsWithoutOrderModule } from './newcredit-claims-without-order/newcredit-claims-without-order.module'
import { RestockFeesNoModalComponent } from './restock-fees-no-modal/restock-fees-no-modal.component'
import { SecondClaimModalComponent } from './second-claim-modal/second-claim-modal.component'

@NgModule({
  declarations: [RestockFeesNoModalComponent, SecondClaimModalComponent],
  imports: [
    CommonModule,
    CreditClaimsHistoryModule,
    CreditClaimsDetailsModule,
    NewcreditClaimsWithOrderModule,
    NewcreditClaimsWithoutOrderModule,
    SharedModule
  ],
  providers: [provideConfig(customOpenCreditClaimAttachmentsLayoutConfig)]
})
export class CreditClaimsModule {}
